import uuid from 'uuid/v4';

export const SESSION_ID = uuid();



// WEBPACK FOOTER //
// ./src/config/session-id.js